import React, { useState } from 'react';
import { RedirectionButton } from './components/Button';
import { DangerousHTML } from './components/DangerousHTML';
import {
  Facebook,
  Instagram,
  LinkedIn,
  Mastodon,
  Spotify,
  Tiktok,
  Twitter,
  WWW,
  YouTube
} from './components/Icons';
import { Modal } from './components/Modal';

const classNames = require('html-classnames');


export interface MemberProps {
  onSeeMoreClick?: (item: MemberProps) => void,
  personName: string,
  role?: string,
  photo?: string,
  description: string,
  descriptionMarkdown?: string,
  facebook?: string,
  instagram?: string,
  twitter?: string,
  tiktok?: string,
  website?: string,
  spotify?: string,
  youtube?: string,
  mastodon?: string,
  linkedin?: string,
  collapsed?: boolean,
}

export interface GroupingProps {
  onItemClick: (item: MemberProps) => void,
  groupingName: string,
  members: Array<MemberProps>,
}

export interface PeopleContentProps {
  title: string,
  groupings: Array<GroupingProps>
}

const Member: React.FC<MemberProps> = (props: MemberProps) => {
  const {
    onSeeMoreClick,
    personName,
    photo,
    role,
    description,
    descriptionMarkdown,
    facebook,
    instagram,
    twitter,
    tiktok,
    website,
    spotify,
    youtube,
    mastodon,
    linkedin,
    collapsed,
  } = props;
  const descriptionClasses = classNames("people__member-description", {
    "--collapsed": collapsed,
    "--full": !descriptionMarkdown,
  })

  const memberClasses = classNames("people__member", {
    "--full": !collapsed,
  })


  return (
    <div className="people__member-wrapper">
      <div className={memberClasses}>
        {collapsed ? (
          <>
            <img className="people__member-photo" src={photo} alt={personName + " - fotografia"} />
            <div className="people__member-content">
              <span className="people__member-name">{personName}</span>{role && <span className="people__member-role">{role}</span>}
              <div className="people__member-social">
                {website && <a href={website} aria-label="WWW" target="_blank"><WWW /></a>}
                {facebook && <a href={facebook} aria-label="Facebook" target="_blank"><Facebook /></a>}
                {instagram && <a href={instagram} aria-label="Instagram" target="_blank"><Instagram /></a>}
                {twitter && <a href={twitter} aria-label="Twitter" target="_blank"><Twitter /></a>}
                {mastodon && <a href={mastodon} aria-label="Mastodon" target="_blank"><Mastodon /></a>}
                {linkedin && <a href={linkedin} aria-label="LinkedIn" target="_blank"><LinkedIn /></a>}
                {tiktok && <a href={tiktok} aria-label="Tiktok" target="_blank"><Tiktok /></a>}
                {youtube && <a href={youtube} aria-label="YouTube" target="_blank"><YouTube /></a>}
                {spotify && <a href={spotify} aria-label="Spotify" target="_blank"><Spotify /></a>}
              </div>
              <div className="people__member-description">
                <div className={descriptionClasses}>
                  {description}
                </div>
                {descriptionMarkdown &&
                  <div className="people__member-description--full">
                    <DangerousHTML element="div" html={descriptionMarkdown} />
                  </div>
                }
              </div>
              <div onClick={() => onSeeMoreClick && onSeeMoreClick(props)} className="people__member-see-more">
                CZYTAJ DALEJ
              </div>
            </div>
          </>
        )
          : (
            <>
              <div className="people__member-info-full">
                <img className="people__member-photo" src={photo} alt={personName + " - fotografia"} />
                <div className="people__member-content">
                  <span className="people__member-name">{personName}</span>{role && <span className="people__member-role">{role}</span>}
                  <div className="people__member-social">
                    {facebook && <a href={facebook} aria-label="Facebook"><Facebook /></a>}
                    {instagram && <a href={instagram} aria-label="Insagram"><Instagram /></a>}
                    {twitter && <a href={twitter} aria-label="Twitter"><Twitter /></a>}
                    {tiktok && <a href={tiktok} aria-label="Tiktok"><Tiktok /></a>}
                  </div>
                </div>
              </div>
              <div className="people__member-description people__member-description-modal">
                {descriptionMarkdown ?
                  <DangerousHTML element="div" html={descriptionMarkdown} />
                  : description
                }
              </div>
            </>
          )
        }
      </div>
    </div>
  );
}

const Grouping: React.FC<GroupingProps> = (
  { groupingName, members, onItemClick }: GroupingProps
) =>
  <>
    <h3 className="people__grouping-name">{groupingName}</h3>
    <div className="people__list">
      {members.map(
        (member: MemberProps, index: number) =>
          <Member key={index} {...member} collapsed={true} onSeeMoreClick={onItemClick} />
      )}
    </div>
  </>;

export const PeopleContent: React.FC<PeopleContentProps> = (props) => {

  const [shownItem, setShownItem] = useState<MemberProps | null>(null);

  return (
    <main className="people">
      <div className="people__top_unit">
        <h2 className="people__title">{props.title}</h2>
        <div className="people__navigation">
          <RedirectionButton
            url="/filary"
            color="#8B235D"
            arrowColor="#FAFAFA"
            text="Filary naszej polityki"
          />
        </div>
      </div>
      {shownItem != null &&
        <Modal onClose={() => setShownItem(null)} hoveringClose={true}>
          <Member {...shownItem} collapsed={false} />
        </Modal>
      }
      <div className="people__grouping">
        {props.groupings.map(
          (grouping: GroupingProps, index: number) =>
            <Grouping key={index} {...grouping} onItemClick={(item: MemberProps) => setShownItem(item)} />
        )}
      </div>
    </main>
  );
}
